<template>
  <QForm class="col-12 row" @submit.prevent="onSubmit">
    <template v-if="mobileStackNavigation">
      <div v-if="!rsm_mobileActiveFilter" class="col-12 mobile-refine-stack mobile-refine-stack--hub">
        <button
          v-if="rsm_mobileHubShowMake"
          type="button"
          class="mobile-refine-stack__row"
          :disabled="isDisabled || isFetchRatebookLoading"
          @click="rsm_openMobileFilter(REFINE_MOBILE_STACK_FILTER.MAKE)"
        >
          <span class="font-nunito text-grey-9">Make</span>
          <div class="mobile-refine-stack__row-end">
            <span v-if="rsm_mobileHubMakeFilterCount > 0" class="mobile-refine-stack__filter-count">{{
              rsm_mobileHubMakeFilterCount
            }}</span>
            <QIcon :name="rsm_chevronRightIcon" color="primary" size="24px" />
          </div>
        </button>
        <button
          type="button"
          class="mobile-refine-stack__row"
          :disabled="isDisabled || isFetchRatebookLoading || !rsm_mobileHubHasSelectedMakes"
          @click="rsm_openMobileFilter(REFINE_MOBILE_STACK_FILTER.MODEL)"
        >
          <span class="font-nunito text-grey-9">Model</span>
          <div class="mobile-refine-stack__row-end">
            <span v-if="rsm_mobileHubModelFilterCount > 0" class="mobile-refine-stack__filter-count">{{
              rsm_mobileHubModelFilterCount
            }}</span>
            <QIcon :name="rsm_chevronRightIcon" color="primary" size="24px" />
          </div>
        </button>
        <button
          type="button"
          class="mobile-refine-stack__row"
          :disabled="isDisabled || isFetchRatebookLoading"
          @click="rsm_openMobileFilter(REFINE_MOBILE_STACK_FILTER.BUDGET)"
        >
          <span class="font-nunito text-grey-9">Budget</span>
          <div class="mobile-refine-stack__row-end">
            <span v-if="rsm_mobileHubBudgetFilterCount > 0" class="mobile-refine-stack__filter-count">{{
              rsm_mobileHubBudgetFilterCount
            }}</span>
            <QIcon :name="rsm_chevronRightIcon" color="primary" size="24px" />
          </div>
        </button>
        <button
          type="button"
          class="mobile-refine-stack__row"
          :disabled="isDisabled || isFetchRatebookLoading"
          @click="rsm_openMobileFilter(REFINE_MOBILE_STACK_FILTER.FUEL)"
        >
          <span class="font-nunito text-grey-9">Fuel type</span>
          <div class="mobile-refine-stack__row-end">
            <span v-if="rsm_mobileHubFuelFilterCount > 0" class="mobile-refine-stack__filter-count">{{
              rsm_mobileHubFuelFilterCount
            }}</span>
            <QIcon :name="rsm_chevronRightIcon" color="primary" size="24px" />
          </div>
        </button>
        <button
          v-if="rsm_mobileHubShowPowerTrain"
          type="button"
          class="mobile-refine-stack__row"
          :disabled="isDisabled || isFetchRatebookLoading"
          @click="rsm_openMobileFilter(REFINE_MOBILE_STACK_FILTER.POWER_TRAIN)"
        >
          <span class="font-nunito text-grey-9">Power train</span>
          <div class="mobile-refine-stack__row-end">
            <span v-if="rsm_mobileHubPowerTrainFilterCount > 0" class="mobile-refine-stack__filter-count">{{
              rsm_mobileHubPowerTrainFilterCount
            }}</span>
            <QIcon :name="rsm_chevronRightIcon" color="primary" size="24px" />
          </div>
        </button>
        <button
          type="button"
          class="mobile-refine-stack__row mobile-refine-stack__row--last"
          :disabled="isDisabled || isFetchRatebookLoading"
          @click="rsm_openMobileFilter(REFINE_MOBILE_STACK_FILTER.STYLE)"
        >
          <span class="font-nunito text-grey-9">Style</span>
          <div class="mobile-refine-stack__row-end">
            <span v-if="rsm_mobileHubStyleFilterCount > 0" class="mobile-refine-stack__filter-count">{{
              rsm_mobileHubStyleFilterCount
            }}</span>
            <QIcon :name="rsm_chevronRightIcon" color="primary" size="24px" />
          </div>
        </button>
      </div>
      <div v-else class="col-12 mobile-refine-stack mobile-refine-stack--detail">
        <MakeFilterSection
          v-if="rsm_mobileActiveFilter === REFINE_MOBILE_STACK_FILTER.MAKE && rsm_mobileHubShowMake"
          v-model="selectedMakes"
          embedded
          :makes="makes"
          :disabled="isDisabled"
          :is-fetch-ratebook-loading="isFetchRatebookLoading"
          @change="rsm_handleFilterChange"
        />
        <template v-if="rsm_mobileActiveFilter === REFINE_MOBILE_STACK_FILTER.MODEL">
          <div v-if="rsm_mobileModelStage === 'makeList'" class="col-12">
            <p class="text-primary text-weight-bold q-mb-md mobile-refine-stack__model-heading">Model</p>
            <p v-if="!filteredMakeModels.length" class="font-nunito text-grey-9 q-mb-md">No models available for the selected makes.</p>
            <button
              v-for="(mm, idx) in filteredMakeModels"
              :key="mm.make"
              type="button"
              class="mobile-refine-stack__row"
              :class="{ 'mobile-refine-stack__row--last': idx === filteredMakeModels.length - 1 }"
              :disabled="isDisabled || isFetchRatebookLoading"
              @click="rsm_openMobileModelForMake(mm.make)"
            >
              <span class="font-nunito text-grey-9">{{ formatWordsAsSentences(mm.make) }}</span>
              <div class="mobile-refine-stack__row-end">
                <span v-if="rsm_selectedModelCountForMake(mm.make) > 0" class="mobile-refine-stack__filter-count">{{
                  rsm_selectedModelCountForMake(mm.make)
                }}</span>
                <QIcon :name="rsm_chevronRightIcon" color="primary" size="24px" />
              </div>
            </button>
          </div>
          <div v-else-if="rsm_mobileModelStage === 'modelsForMake' && rsm_mobileModelMakeKey" class="col-12">
            <p class="text-primary font-nunito text-weight-bold q-mb-md model-filter-section-heading">
              Model: {{ formatWordsAsSentences(rsm_mobileModelMakeKey) }}
            </p>
            <RefineSearchMultiCheckbox
              label="Search models"
              :options="rsm_mobileModelCheckboxOptions"
              :value="rsm_mobileModelCheckboxValue"
              :disabled="isDisabled || isFetchRatebookLoading"
              @input="rsm_onMobileModelCheckboxInput"
              @change="rsm_handleFilterChange"
            />
          </div>
        </template>
        <BudgetFilterSection
          v-if="rsm_mobileActiveFilter === REFINE_MOBILE_STACK_FILTER.BUDGET"
          embedded
          :selected-price.sync="selectedPrice"
          :selected-weekly-budget.sync="selectedWeeklyBudget"
          :budget-type.sync="budgetType"
          :price-options="priceOptions"
          :weekly-options="weeklyOptions"
          :disabled="isDisabled"
          :is-fetch-ratebook-loading="isFetchRatebookLoading"
          @change="rsm_handleFilterChange"
        />
        <FuelTypeFilterSection
          v-if="rsm_mobileActiveFilter === REFINE_MOBILE_STACK_FILTER.FUEL"
          v-model="selectedFuelType"
          embedded
          :fuel-type-options="fuelTypeOptions"
          :disabled="isDisabled"
          :is-fetch-ratebook-loading="isFetchRatebookLoading"
          @change="rsm_handleFilterChange"
        />
        <PowerTrainFilterSection
          v-if="rsm_mobileActiveFilter === REFINE_MOBILE_STACK_FILTER.POWER_TRAIN && rsm_mobileHubShowPowerTrain"
          embedded
          :selected-power-train.sync="selectedPowerTrain"
          :selected-tranmission.sync="selectedTranmission"
          :drive-train-options="driveTrainOptions"
          :tranmission-options="tranmissionOptions"
          :disabled="isDisabled"
          :is-fetch-ratebook-loading="isFetchRatebookLoading"
          @change="rsm_handleFilterChange"
        />
        <StyleFilterSection
          v-if="rsm_mobileActiveFilter === REFINE_MOBILE_STACK_FILTER.STYLE"
          embedded
          :selected-body-type.sync="selectedBodyType"
          :selected-cab-type.sync="selectedCabType"
          :selected-vehicle-category.sync="selectedVehicleCategory"
          :selected-seat.sync="selectedSeat"
          :body-style-options="bodyStyleOptions"
          :cab-type-options="cabTypeOptions"
          :vehicle-category-options="vehicleCategoryOptions"
          :seat-options="seatOptions"
          :disabled="isDisabled"
          :is-fetch-ratebook-loading="isFetchRatebookLoading"
          @change="rsm_handleFilterChange"
        />
      </div>
    </template>
    <template v-else>
      <MakeFilterSection
        v-if="makes && makes.length > 1"
        v-model="selectedMakes"
        :makes="makes"
        :disabled="isDisabled"
        :is-fetch-ratebook-loading="isFetchRatebookLoading"
        @change="handleFilterChange"
      />
      <ModelFilterSection
        v-model="selectedModel"
        :filtered-make-models="filteredMakeModels"
        :selected-makes="selectedMakes"
        :disabled="isDisabled"
        :is-fetch-ratebook-loading="isFetchRatebookLoading"
        @model-updated="handleModelUpdated"
        @change="handleFilterChange"
      />
      <BudgetFilterSection
        :selected-price.sync="selectedPrice"
        :selected-weekly-budget.sync="selectedWeeklyBudget"
        :budget-type.sync="budgetType"
        :price-options="priceOptions"
        :weekly-options="weeklyOptions"
        :disabled="isDisabled"
        :is-fetch-ratebook-loading="isFetchRatebookLoading"
        @change="handleFilterChange"
      />
      <FuelTypeFilterSection
        v-model="selectedFuelType"
        :fuel-type-options="fuelTypeOptions"
        :disabled="isDisabled"
        :is-fetch-ratebook-loading="isFetchRatebookLoading"
        @change="handleFilterChange"
      />
      <PowerTrainFilterSection
        :selected-power-train.sync="selectedPowerTrain"
        :selected-tranmission.sync="selectedTranmission"
        :drive-train-options="driveTrainOptions"
        :tranmission-options="tranmissionOptions"
        :disabled="isDisabled"
        :is-fetch-ratebook-loading="isFetchRatebookLoading"
        @change="handleFilterChange"
      />
      <StyleFilterSection
        :selected-body-type.sync="selectedBodyType"
        :selected-cab-type.sync="selectedCabType"
        :selected-vehicle-category.sync="selectedVehicleCategory"
        :selected-seat.sync="selectedSeat"
        :body-style-options="bodyStyleOptions"
        :cab-type-options="cabTypeOptions"
        :vehicle-category-options="vehicleCategoryOptions"
        :seat-options="seatOptions"
        :disabled="isDisabled"
        :is-fetch-ratebook-loading="isFetchRatebookLoading"
        @change="handleFilterChange"
      />
    </template>

    <CalculatorButton
      v-if="!hideSubmitButton && !mobileStackNavigation"
      color="primary"
      hasChevronIcon
      outlined
      class="col-12 q-mt-md calculator-button"
      rounded
      label="Update search"
      type="submit"
      :loading="isFetchRatebookLoading"
      :disabled="isBtnDisabled || isDisabled || isFetchRatebookLoading"
    />
  </QForm>
</template>

<script>
import { QForm, QIcon } from 'quasar';
import { sortBy } from 'lodash';
import CalculatorButton from '../CalculatorButton';
import MakeFilterSection from './MakeFilterSection';
import ModelFilterSection from './ModelFilterSection';
import BudgetFilterSection from './BudgetFilterSection';
import FuelTypeFilterSection from './FuelTypeFilterSection';
import PowerTrainFilterSection from './PowerTrainFilterSection';
import StyleFilterSection from './StyleFilterSection';
import RefineSearchMultiCheckbox from './RefineSearchMultiCheckbox';
import { searchFilterTypesMixin, fetchRatebookMixin, refineSearchFormStateMixin, refineSearchMobileMixin } from '@/mixins/calculator';
import { formatWordsAsSentences } from '../../../utils/calculator/wordFormatter';
import { DEFAULT_LEASE_TERM } from '../../../utils/constants';
import { oneTagTracker } from '../../../utils/one-tag-tracker';
import { buildSearchParams } from '../../../utils/refineSearchParamsBuilder';
import { updateUrlWithSearchParams } from '../../../utils/refineSearchUrlHandler';
import { trackRefineSearchUpdate } from '../../../utils/refineSearchGtmTracker';
// import SelectField from '../../Atoms/SelectField';
export default {
  mixins: [searchFilterTypesMixin, fetchRatebookMixin, refineSearchFormStateMixin, refineSearchMobileMixin],
  name: 'RefineSearchContainer',
  props: {
    sortedBy: {
      type: Object,
      default: () => ({
        value: 'vehicle_description'
      })
    },
    sortedOrder: {
      type: String,
      default: 'ASC'
    },
    pageSize: {
      type: Number,
      default: 25
    },
    currentPage: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {}
    },
    leaseTerm: {
      type: Object,
      default: () => ({ value: DEFAULT_LEASE_TERM })
    },
    /** When true, omit the built-in submit button (e.g. VehicleResultFilterDrawer renders its own footer). */
    hideSubmitButton: {
      type: Boolean,
      default: false
    },
    /**
     * Mobile filter drawer: show a hub list with chevrons and drill into one category per screen
     * instead of accordion dropdowns.
     */
    mobileStackNavigation: {
      type: Boolean,
      default: false
    },
    /** Weekly/monthly from VehicleResultFilterDrawer; used on submit so URL/API match drawer toggles (internal budgetType can lag). */
    drawerRepayment: {
      type: String,
      default: null
    }
  },
  computed: {
    makes() {
      return (
        sortBy(
          this.makesFromVehicleSearchConfig?.map((value, index) => ({
            id: index++,
            label: this.formatWordsAsSentences(value),
            value: value.toUpperCase()
          })),
          'label'
        ) || []
      );
    },
    makeModels() {
      const modelsByMake = this.vehicleSearchConfig?.modelsByMake || [];
      return modelsByMake.map(({ make, models }) => ({
        make: String(make).toUpperCase(),
        models: (models || []).map((m) => String(m).toUpperCase())
      }));
    },
    filteredMakeModels() {
      return this.makeModels.filter((value) => this.filteredSelectedMakes.includes(value.make));
    },
    filteredSelectedMakes() {
      return Object.keys(this.selectedMakes).filter((make) => this.selectedMakes[make]);
    }
  },
  methods: {
    formatWordsAsSentences,
    resetLocalState() {
      this.rsm_resetLocalState();
    },
    handleFilterChange() {
      this.enableSubmitButton();
    },
    handleModelUpdated() {
      this.enableSubmitButton();
    },
    /**
     * Submit the refine form from a parent `ref` (e.g. drawer “Update search” outside QForm).
     * @returns {Promise<void>|void} Same as internal `onSubmit` (async when validation/network apply).
     */
    submitSearch() {
      return this.onSubmit();
    },
    async onSubmit() {
      this.disableSubmitButton();

      // Build form state object
      const budgetTypeForSubmit = this.mobileStackNavigation && this.drawerRepayment ? this.drawerRepayment : this.budgetType;

      const formState = {
        selectedMakes: this.selectedMakes,
        selectedModel: this.selectedModel,
        selectedFuelType: this.selectedFuelType,
        selectedBodyType: this.selectedBodyType,
        selectedCabType: this.selectedCabType,
        selectedVehicleCategory: this.selectedVehicleCategory,
        selectedSeat: this.selectedSeat,
        selectedPowerTrain: this.selectedPowerTrain,
        selectedTranmission: this.selectedTranmission,
        selectedWeeklyBudget: this.selectedWeeklyBudget,
        selectedPrice: this.selectedPrice,
        budgetType: budgetTypeForSubmit
      };

      // Build search parameters
      let params = buildSearchParams(formState, { value: this.value });
      const pair = params.pair || [];

      // Mobile drawer: persist sort + repayment (budgetType) in query only on "Update search", with refine filters.
      if (this.mobileStackNavigation) {
        params = {
          ...params,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder
        };
      }

      // Build options for ratebook fetch
      const options = {
        pageSize: this.pageSize,
        currentPage: this.currentPage,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder,
        minDuration: this.leaseTerm?.value || DEFAULT_LEASE_TERM,
        maxDuration: this.leaseTerm?.value || DEFAULT_LEASE_TERM
      };

      // Fetch ratebook
      await this.fetchRatebook({ ...params, ...options }, true);

      // Update URL with search parameters (router.replace keeps $route.query in sync with the bar)
      updateUrlWithSearchParams(params, pair, this.$router);

      // Track GTM event
      const makes = this.filterResultsWithTrueValues(this.selectedMakes);
      const fuelTypes = this.filterResultsWithTrueValues(this.selectedFuelType);
      const bodyTypes = this.filterResultsWithTrueValues(this.selectedBodyType);
      trackRefineSearchUpdate(this.$gtm, {
        makes,
        fuelTypes,
        bodyTypes
      });

      // Track oneTag event
      oneTagTracker.trackCalculatorPage(this.$route);

      // Emit filter params only (sort/repayment for drawer live on parent via .sync until submit URL merge).
      const emittedParams = { ...params };
      delete emittedParams.sortBy;
      delete emittedParams.sortOrder;
      this.$emit('input', emittedParams);
      this.$emit('submit');
    }
  },
  async mounted() {
    // Initialize after component is mounted to ensure filter sections are ready
    await this.$nextTick();

    // Set initialization flag to prevent watchers from enabling button during setup
    this._isInitializing = true;

    this.getInitialSelectedMakes();
    // Needed when makes is already populated at mount (watcher only runs on change)
    this.rsm_applySingleMakeSelection();
    await this.getInitialSelectedModels();
    await this.getInitialOptions(); // Wait for options to be initialized (may need vehicleCategoryOptions)

    // Ensure button is disabled after initialization
    this.isBtnDisabled = true;

    // Clear initialization flag after setup is complete
    await this.$nextTick();
    this._isInitializing = false;
  },
  components: {
    QForm,
    QIcon,
    CalculatorButton,
    MakeFilterSection,
    ModelFilterSection,
    BudgetFilterSection,
    FuelTypeFilterSection,
    PowerTrainFilterSection,
    StyleFilterSection,
    RefineSearchMultiCheckbox
  }
};
</script>

<style lang="sass" scoped>
@import '../../../styles/calculator/mobile-refine-stack'

.weekly-budget
  width: 95%
  margin: 0 auto
</style>
